import { useContext } from 'react';
import { ThemeContext } from './ThemeProvider';
import type { ThemeContextType } from './types';

export function useThemeMode(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useThemeMode must be used within ThemeProvider');
  return context;
}
